<template>
  <div>
    <div class="loading" v-if="loading">Loading...</div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <div v-if="post" class="container mt-5">
      <!-- <h1>{{ post.title }}</h1> -->
      <!-- <img v-if="post.image" :src="imageUrlFor(post.image).width(480)" /> -->
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 g-0">
        <div class="col staff-hero">
          <img
            v-if="post.image"
            :src="imageUrlFor(post.image)"
            alt=""
            class="hero rounded-start"
          />
        </div>
        <div class="col staff-name text-white rounded-end">
          <div class="staff-name-text w-75">
            <h1>{{ post.title }}</h1>
            <p>{{ post.position }}</p>
          </div>
        </div>
      </div>
      <!-- <div class="" v-for="post in post.category" :key="post.category_id">
          <h6>{{ post }}</h6>
        </div> -->
      <section class="more-info container">
        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 g-5">
          <div class="col text-start">
            <h1 class="biography">Biography</h1>
            <p class="biography-p mt-4"><SanityBlocks :blocks="blocks" /></p>

            <div class="mt-5 mb-5">
              <h1 class="biography">Research Interests</h1>
              <ul
                class="list-group"
                v-for="post in post.category"
                :key="post.category_id"
              >
                <li class="list-group-item">{{ post }}</li>
              </ul>
            </div>
          </div>
          <div class="col">
            <div class="container">
              <h1 class="biography">Other Info</h1>
              <ul class="list-group list-group-flush mt-4 text-start">
                <li
                  class="list-group-item info d-flex flex-row justify-content-between"
                >
                  <p class="mb-0 fw-bold">Highest Education</p>
                  <p class="mb-0">{{ post.education }}</p>
                </li>
                <li
                  class="list-group-item info d-flex flex-row justify-content-between"
                >
                  <p class="mb-0 fw-bold">Email</p>
                  <p class="mb-0">{{ post.email }}</p>
                </li>

                <li
                  class="list-group-item info d-flex flex-row justify-content-between"
                >
                  <p class="mb-0 fw-bold">Orcid ID</p>
                  <p class="mb-0">{{ post.orcid }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { SanityBlocks } from "sanity-blocks-vue-component";
import sanity from "../client";
import imageUrlBuilder from "@sanity/image-url";

const imageBuilder = imageUrlBuilder(sanity);

const query = `*[slug.current == $slug] {
      _id,
      title,
      slug,
      body, 
      email,
      position,
      education,
      orcid,
      "category": categories[]->title,
     "image": mainImage{
      asset->{
      _id,
      url
    }
    },
  
    }[0]
    `;

export default {
  name: "SinglePost",
  components: { SanityBlocks },
  data() {
    return {
      loading: true,
      post: [],
      blocks: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    imageUrlFor(source) {
      return imageBuilder.image(source);
    },
    fetchData() {
      this.error = this.post = null;
      this.loading = true;

      sanity.fetch(query, { slug: this.$route.params.slug }).then(
        (post) => {
          this.loading = false;
          this.post = post;
          // console.log(post);
          this.blocks = post.body;
        },
        (error) => {
          this.error = error;
        }
      );
    },
  },
};
</script>

<style scoped>
.more-info {
  margin-top: 100px;
}
h1 {
  text-align: center;
}
h6 {
  color: #aaa;
  padding: 1em;
}

.staff-hero {
  height: 70vh;
}
.hero {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}
.staff-name {
  position: relative;
  background: #476f6e;
}
.staff-name-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.staff-name-text h1 {
  font-family: "Playfair Display";
  font-size: 50px;
  text-align: start;
}
.staff-name-text p {
  font-family: "Barlow";
  font-size: 30px;
  text-align: start;
}
.biography {
  font-family: "Playfair Display";
  font-size: 35px;
  text-align: start;
  text-decoration: underline;
}
.biography-p{
  text-align: justify;
}

@media (max-width: 728px) {
  .staff-name-text {
    background: #476f6e !important;
    padding: 20px !important;
    border-radius: 10px !important;
  }
  .staff-name-text h1 {
    text-align: center !important;
    font-size: 30px !important;
  }
  .staff-name-text p {
    text-align: center !important;
    font-size: 15px !important;
  }
  .more-info {
    margin-top: 150px !important;
  }
  .info {
    display: block !important;
  }
}
</style>
